import React, {Component} from 'react';
import {Button} from "reactstrap";

class StickButton extends Component {

	constructor(props) {
		super(props);

		this.state = {};
	}

	render() {
		let cloneProps = Object.assign({}, this.props);

		if (cloneProps.title) {
			cloneProps.toggle = "tooltip";
			cloneProps.placement = "top";
			cloneProps.rel = "tooltip";
		}

		return (
			<Button {...cloneProps} style={this.props.style} className={this.props.className}>
				<label className={this.props.labelClass} style={{margin: '3px 0 4px 0'}}>{this.props.label}</label>
				{this.props.children}
			</Button>
		)
	}
}

export default StickButton;